import './Header.scss';
import ZionTitle from "../../../assets/zion_title.png";
import {useCommonStore} from "../../../hooks/useCommonStore";
import api from "../../../utils/api";
import Button from "../../Button/Button";
import {Link, useNavigate} from "react-router-dom";
import {useLocation} from "react-router-dom";
import {useState} from "react";
import {useResponsiveLayout} from "../../../hooks/useResponsiveLayout";
import {FormattedMessage, useIntl} from "react-intl";
import cn from "classnames";
import { slide as Menu } from 'react-burger-menu'
import {faArrowLeft, faArrowRightFromBracket} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import LangDropdown from "../../LangDropdown/LangDropdown";

const Submenu = ({element, location, isDesktop}) => {
  return (
    <Link
      to={element.link}
      className={cn({'menu-item-sub': !isDesktop}, {active: location.pathname === element.link})}
    >
      <FormattedMessage id={element.name} />
    </Link>
  );
}

const Header = ({ setAccessModal }) => {
  const {access} = useCommonStore();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.split('/')[1];
  const {isDesktop} = useResponsiveLayout();
  const intl = useIntl();

  // PC는 서브메뉴 기본적으로 false, 모바일은 현재 페이지의 서브메뉴 오픈
  const [studyMenuOpen, setStudyMenuOpen] = useState(!isDesktop ? path === 'study' : false);
  const [infoMenuOpen, setInfoMenuOpen] = useState(!isDesktop ? path === 'info' : false);

  const submenu = {
    study: [
      {link: '/study/live', name: '@menu_study_live'},
      {link: '/study/record', name: '@menu_study_record'},
      {link: '/study/homework', name: '@menu_study_homework'},
      {link: '/study/test', name: '@menu_study_test'},
    ],
    info: [
      {link: '/info/notice', name: '@menu_info_notice'},
      {link: '/info/schedule', name: '@menu_info_schedule'},
      {link: '/info/inquiry', name: '@menu_info_inquiry'},
    ]
  }

  const handleSubmenu = (name) => {
    setStudyMenuOpen(false);
    setInfoMenuOpen(false);

    switch (name) {
      case 'study':
        setStudyMenuOpen(!studyMenuOpen);
        break;
      case 'info':
        setInfoMenuOpen(!infoMenuOpen);
        break;
      default:
        break;
    }
  }

  const handleLogout = async () => {
    if (window.confirm(intl.formatMessage({id: '@confirm_logout'}))) {
      window.localStorage.clear();
      await api.get('/v1/auth/logout');
      const redirectUrl = encodeURI(process.env.REACT_APP_FRONT_URL);
      window.location.href = `https://auth.ziongroup.net/oauth/logout?continue=${redirectUrl}`;
    }
  }

  const handleGoBack = () => {
    if (window.confirm(intl.formatMessage({id: '@exam_room_exit_modal'}))) {
      navigate('/main');
    }
  }

  // if (isDesktop) {
  //   return (
  //     <div className='Header'>
  //       <section className='left-section'>
  //         <img
  //           src={ZionTitle}
  //           alt='ZionTitle'
  //           className='zion-logo'
  //           onClick={() => navigate('/main')}
  //         />
  //
  //         <div className={'nav'}>
  //           <div
  //             className={cn('menu', {active: path === 'study'})}
  //             onMouseEnter={() => setStudyMenuOpen(true)}
  //             onMouseLeave={() => setStudyMenuOpen(false)}
  //           >
  //             <FormattedMessage id='@menu_study' />
  //             <div className={cn('submenu', {active: studyMenuOpen})}>
  //               {
  //                 submenu.study.map((element, i) => {
  //                   return <Submenu element={element} key={i} location={location} isDesktop={isDesktop}/>
  //                 })
  //               }
  //             </div>
  //           </div>
  //           <div
  //             className={cn('menu', {active: path === 'info'})}
  //             onMouseEnter={() => setInfoMenuOpen(true)}
  //             onMouseLeave={() => setInfoMenuOpen(false)}
  //           >
  //             <FormattedMessage id='@menu_info' />
  //             <div className={cn('submenu', {active: infoMenuOpen})}>
  //               {
  //                 submenu.info.map((element, i) => {
  //                   return <Submenu element={element} key={i} location={location} isDesktop={isDesktop}/>
  //                 })
  //               }
  //             </div>
  //           </div>
  //         </div>
  //       </section>
  //
  //       <section className='right-section'>
  //         <Button
  //           className='center-box'
  //           text={access.label}
  //           onClick={() => setAccessModal(true)}
  //         />
  //         <FontAwesomeIcon icon={faPowerOff} className='logout'/>
  //       </section>
  //     </div>
  //   )
  // } else {
    return (
      <div className='Header-mob'>
        {/*<Menu>*/}
        {/*  <img*/}
        {/*    src={ZionTitle}*/}
        {/*    alt='ZionTitle'*/}
        {/*    className='zion-logo'*/}
        {/*    onClick={() => navigate('/main')}*/}
        {/*  />*/}

        {/*  <div className='menu-item' onClick={() => handleSubmenu('study')}>*/}
        {/*    <FormattedMessage id='@menu_study'/>*/}
        {/*  </div>*/}
        {/*  <ul className={cn('submenu-wrap', 'four', {open: studyMenuOpen})}>*/}
        {/*    {*/}
        {/*      submenu.study.map((element, i) => {*/}
        {/*        return <Submenu key={i} element={element} location={location}/>*/}
        {/*      })*/}
        {/*    }*/}
        {/*  </ul>*/}

        {/*  <div className='menu-item' onClick={() => handleSubmenu('info')}>*/}
        {/*    <FormattedMessage id='@menu_info' />*/}
        {/*  </div>*/}
        {/*  <ul className={cn('submenu-wrap', 'three', {open: infoMenuOpen})}>*/}
        {/*    {*/}
        {/*      submenu.info.map((element, i) => {*/}
        {/*        return <Submenu key={i} element={element} location={location}/>*/}
        {/*      })*/}
        {/*    }*/}
        {/*  </ul>*/}
        {/*</Menu>*/}

        {
          path === 'main' &&
          <>
            <h3>
              <FormattedMessage id='@title' />
            </h3>
            <section className='right-section'>
              <LangDropdown />
              <FontAwesomeIcon
                icon={faArrowRightFromBracket}
                className='logout'
                onClick={handleLogout}
              />
            </section>
          </>
        }

        {
          path === 'exam-room' &&
          <>
            <FontAwesomeIcon
              icon={faArrowLeft}
              className='arrow-left'
              onClick={handleGoBack}
            />
            <h3>
              <FormattedMessage id='@exam_main_title' />
            </h3>
            <section className='right-section' />
          </>
        }
      </div>
    )
  // }
}

export default Header;